// Navbar/index.jsx
import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { useLang } from '../../../hooks/useLang';
import { FaHome, FaPhone, FaTimes, FaBars } from "react-icons/fa";
import logo from "../../../assets/images/logo-small.webp";
import { getNavbarLinks } from "../../../data/navLinks";
import "./Navbar.css";

import {
  prefetchNosotros,
  prefetchServicios,
  prefetchPortafolio,
  prefetchBlog,
  prefetchContacto
} from "../../../preloaders";

// Map paths to preloader functions
const preloaders = {
  "/nosotros": prefetchNosotros,
  "/servicios": prefetchServicios,
  "/portafolio": prefetchPortafolio,
  "/blog": prefetchBlog,
  "/contacto": prefetchContacto,
};

const Navbar = () => {
  const { t } = useLang();
  const [menuAbierto, setMenuAbierto] = useState(false);

  // Use centralized nav links
  const navLinks = getNavbarLinks();

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };
  // ...

  const closeMenu = () => {
    setMenuAbierto(false);
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (menuAbierto) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [menuAbierto]);

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`} role="banner">
      <div className="navbar-container">
        {/* El overlay solo se muestra en móvil cuando el menú está abierto */}
        {menuAbierto && (
          <div
            className="overlay"
            onClick={closeMenu}
            onKeyDown={(e) => e.key === "Escape" && closeMenu()}
            role="button"
            tabIndex="0"
            aria-label="Cerrar menú"
          ></div>
        )}

        <div className="navbar-content">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <img src={logo} alt="Logo PIKDOV STUDIO" width="40" height="38" />
            <span>PIKDOV STUDIO</span>
          </Link>



          <nav className={`navbar-nav ${menuAbierto ? "abierto" : ""}`} role="navigation">
            <ul className="nav-links">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    onClick={closeMenu}
                    onMouseEnter={() => preloaders[link.to]?.()}
                  >
                    {t(link.textKey)}
                    {link.to === "/" && <FaHome />}
                  </NavLink>
                </li>
              ))}
            </ul>
            <NavLink
              to="/contacto"
              className={({ isActive }) => `btn-contacto-nav ${isActive ? "active" : ""}`}
              onClick={closeMenu}
            >
              {t('nav.contact')} <FaPhone />
            </NavLink>
          </nav>

          <button
            type="button"
            className="menu-hamburguesa"
            onClick={toggleMenu}
            aria-label={menuAbierto ? t("nav.menu_close") : t("nav.menu_open")}
            aria-expanded={menuAbierto}
          >
            {menuAbierto ? (
              <FaTimes />
            ) : (
              <FaBars />
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default React.memo(Navbar);